module.exports = "/shared/img/virtual-football.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/virtual-football.png
// module id = 459
// module chunks = 13